import { createSlice } from '@reduxjs/toolkit';

const initialState = { token: null, isAuthenticated: false };

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		SET_TOKEN: (state, action) => {
			state.isAuthenticated = true;
			state.token = action.payload?.token;
		},
		REMOVE_TOKEN: (state, action) => {
			state.isAuthenticated = false;
			state.token = null;
		},
	},
});

export const { REMOVE_TOKEN, SET_TOKEN } = authSlice.actions;

export default authSlice.reducer;
